// extracted by mini-css-extract-plugin
module.exports = {"successContainer":"TransactionSuccess_successContainer__2HWYa","successContent":"TransactionSuccess_successContent__1kKdV","successText":"TransactionSuccess_successText__3ZYIN"};